import http from '../httpConfig';
import { Login, ForgotPassword, ResetPassword, VerifyOtp } from '../interfaces/auth.interface';
import { Theme, Permissions } from '../interfaces/common';
import { API_ENDPOINTS } from '../utils/apiConstant';
import { LOCAL_STORAGE_KEYS } from '../utils/appConstant';
import { encryptData, decryptData } from '../utils/methods';

const login = (payload: Login) => {
  return http.post(API_ENDPOINTS.login, {
    phone: payload.phoneNumber,
  });
};

const forgotPassword = (_payload: ForgotPassword) => {
  // Mock data
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        data: {},
        message: 'Password reset email sent successfully',
      });
    }, 500);
  });

  // return http.post(API_ENDPOINTS.forgotPassword, payload);
};

const resetPassword = (_payload: ResetPassword) => {
  // Mock data
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        data: {},
        message: 'Password reset successfully',
      });
    }, 500);
  });

  // return http.post(API_ENDPOINTS.resetPassword, payload);
};

const storeLoggedInUser = (user: any) => {
  const encrypted = encryptData(user);
  localStorage.setItem(LOCAL_STORAGE_KEYS.loggedInUser, encrypted);
};

const getLoggedInUser = () => {
  const data = localStorage.getItem(LOCAL_STORAGE_KEYS.loggedInUser);
  return data ? decryptData(data) : {};
};

const storeIsSystemAdmin = (isSystemAdmin: string) => {
  const encrypted = encryptData(isSystemAdmin);
  localStorage.setItem(LOCAL_STORAGE_KEYS.isSystemAdmin, encrypted);
};

const getIsSystemAdmin = () => {
  const data = localStorage.getItem(LOCAL_STORAGE_KEYS.isSystemAdmin);
  return data && decryptData(data) ? decryptData(data) : '';
};

const storeLoading = (loading: string) => {
  const encrypted = encryptData(loading);
  localStorage.setItem(LOCAL_STORAGE_KEYS.loading, encrypted);
};

const getLoading = () => {
  const data = localStorage.getItem(LOCAL_STORAGE_KEYS.loading);
  return data && decryptData(data) ? decryptData(data) : '';
};

const storeException = (exception: string) => {
  const encrypted = encryptData(exception);
  localStorage.setItem(LOCAL_STORAGE_KEYS.exception, encrypted);
};

const getException = () => {
  const data = localStorage.getItem(LOCAL_STORAGE_KEYS.exception);
  return data && decryptData(data) ? decryptData(data) : '';
};

const storeToken = (token: string) => {
  const encrypted = encryptData(token);
  localStorage.setItem(LOCAL_STORAGE_KEYS.token, encrypted);
};

const getToken = () => {
  const data = localStorage.getItem(LOCAL_STORAGE_KEYS.token);
  return data && decryptData(data) ? decryptData(data) : '';
};

const storeTheme = (theme: Theme) => {
  const encrypted = encryptData(theme);
  localStorage.setItem(LOCAL_STORAGE_KEYS.theme, encrypted);
};

const getTheme = (): Theme => {
  const data = localStorage.getItem(LOCAL_STORAGE_KEYS.theme);
  return data && decryptData(data) ? decryptData(data) : 'light';
};

const storePermissions = (permissions: Permissions) => {
  const encrypted = encryptData(permissions);
  localStorage.setItem(LOCAL_STORAGE_KEYS.permissions, encrypted);
};

const getPermissions = () => {
  const data = localStorage.getItem(LOCAL_STORAGE_KEYS.permissions);
  return data ? decryptData(data) : [];
};

const logout = async () => {
  // Mock data
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ data: {}, message: 'Logged out successfully' });
    }, 500);
  });

  // await http.post(API_ENDPOINTS.logout);
};

const verifyOtp = (payload: VerifyOtp) => {
  return http.post(API_ENDPOINTS.verifyOtp, payload);
};

const AuthService = {
  login,
  forgotPassword,
  resetPassword,
  getLoggedInUser,
  storeLoggedInUser,
  storeIsSystemAdmin,
  storeException,
  getIsSystemAdmin,
  getToken,
  storeToken,
  storePermissions,
  getPermissions,
  storeTheme,
  getTheme,
  getException,
  storeLoading,
  getLoading,
  logout,
  verifyOtp,
};

export default AuthService;
